import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-modal-footer',
    templateUrl: './modal-footer.component.html',
    styleUrls: ['./modal-footer.component.scss'],
    standalone: false
})
export class ModalFooterComponent implements OnInit {

  @Input()
  okButtonText: string = '';

  @Input()
  disableOkButton: boolean = false;

  @Input()
  showCancelButton: boolean = true;

  @Input()
  cancelButtonText: string = '';

  @Input()
  showRequiredFieldsIndicator: boolean = false;

  @Output()
  okButtonPressed: EventEmitter<boolean> = new EventEmitter;

  @Output()
  cancelButtonPressed: EventEmitter<boolean> = new EventEmitter;



  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    if (this.cancelButtonText === null) {
      //hide button
    } else if (this.cancelButtonText == undefined || this.cancelButtonText.length === 0) {
      this.cancelButtonText = this.translate.instant('Cancel');
    }
  }

  onCancel() {
    this.cancelButtonPressed.emit(true);
  }

  onOk() {
    this.okButtonPressed.emit(true);
  }

}
